export default __webpack_public_path__ + "static/screeny-110-gpz-unica-am-3-30f578b167b4a8597d13e7951c77293e.jpg";